// extracted by mini-css-extract-plugin
export default {"broadcast-edit__form":"CreateBroadcastPopup_broadcast-edit__form__IF9j+","broadcast-edit__field-section":"CreateBroadcastPopup_broadcast-edit__field-section__Ev-Za"};